export const ON_CATEGORY_IMAGE_UPLOAD_SUCCESS = 'ON_CATEGORY_IMAGE_UPLOAD_SUCCESS';
export const ON_CATEGORY_IMAGE_UPLOAD_FAILURE = 'ON_CATEGORY_IMAGE_UPLOAD_FAILURE';
